export default "__VITE_ASSET__Cf3q3vgC__"